// extracted by mini-css-extract-plugin
var _1 = "AttachServiceRequestsModal-moduleaiSuggestLoaderOverlay__NjvTq AIGretaLoader-moduleoverlay__sYzbh";
var _2 = "AttachServiceRequestsModal-moduleemptyState__aNdB6";
var _3 = "AttachServiceRequestsModal-modulefooter___pIuh";
var _4 = "AttachServiceRequestsModal-moduletable__sikxO TableComponent-moduleTable__mhqNq";
export { _1 as "aiSuggestLoaderOverlay", _2 as "emptyState", _3 as "footer", _4 as "table" }
